import * as React from 'react';
import isEqual from 'react-fast-compare';
import { useForm } from 'react-hook-form';
import set from 'set-value';
import { isPlainObject } from '../../utils/lang.js';
import { usePrevious } from '../../utils/react.js';

function expandObject(maybeObj) {
  if (!isPlainObject(maybeObj)) return {};
  return Object.keys(maybeObj).reduce(function (expanded, path) {
    set(expanded, path, maybeObj[path]);
    return expanded;
  }, {});
}
function useReactHookForm(props, ref) {
  var defaultValues = props.defaultValues,
    _props$mode = props.mode,
    mode = _props$mode === void 0 ? "onSubmit" : _props$mode,
    onChange = props.onChange,
    _props$reValidateMode = props.reValidateMode,
    reValidateMode = _props$reValidateMode === void 0 ? "onBlur" : _props$reValidateMode;
  var defaultValuesMemo = React.useMemo(function () {
    return expandObject(defaultValues);
  }, []);
  var methods = useForm({
    defaultValues: defaultValuesMemo,
    mode: mode,
    reValidateMode: reValidateMode
  });
  var handleSubmit = methods.handleSubmit,
    reset = methods.reset,
    setFocus = methods.setFocus,
    trigger = methods.trigger,
    watch = methods.watch;
  React.useImperativeHandle(ref, function () {
    return {
      reset: reset,
      handleSubmit: handleSubmit,
      setFocus: setFocus,
      trigger: trigger
    };
  });
  React.useEffect(function () {
    var subscription = watch(function (value) {
      if (typeof onChange === "function") onChange(value);
    });
    return function () {
      return subscription.unsubscribe();
    };
  }, [onChange, watch]);
  var hasInitialized = React.useRef(false);
  var prevDefaultValues = usePrevious(defaultValues);
  React.useEffect(function () {
    if (hasInitialized.current && !isEqual(defaultValues, prevDefaultValues)) {
      reset(expandObject(defaultValues));
    }
    hasInitialized.current = true;
  }, [defaultValues]);
  return methods;
}

export { useReactHookForm };
